import { Component, OnInit } from '@angular/core';
import { AbstractWidgetComponent, WidgetStyle } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { TransportDetailsLayoutService } from '../../../../components/transport-details/transport-details-layout.service';
import { TerminalContextConstants } from '@sdbn/tmc-common';
import { TranslationService } from '@sdbn/common';
import { TransportDetailLayout, TransportDetailMode } from '../../../../common/configuration/transport.configuration';
import { Transport } from '../../../../common/model/transport.model';
import { TransportDetailsLayoutConverter } from '../../../../common/components/tmp/transport-details-layout-converter.service';

@Component({
  selector: 'app-transport-registration-masterdata',
  templateUrl: './transport-registration-masterdata.component.html',
  styleUrls: ['./transport-registration-masterdata.component.scss']
})
export class TransportRegistrationMasterdataComponent extends AbstractWidgetComponent implements OnInit {

  TransportDetailMode = TransportDetailMode;

  layoutDefinition: TransportDetailLayout;
  transportDetails: Transport;

  requiresValueConfirmation = false;
  showHints = false;

  constructor(
    private transportDetailsLayoutService: TransportDetailsLayoutService,
    public translationService: TranslationService,
    transportDetailsLayoutConverter: TransportDetailsLayoutConverter
  ) {
    super();
    this.layoutDefinition = transportDetailsLayoutConverter.convert(
      this.transportDetailsLayoutService.createRegistrationTerminalMasterdataLayout()
    );
  }

  ngOnInit(): void {
    this.readOptions();
  }

  onContextChange(contextChange: ContextChange) {
    if (contextChange.key === 'requires_value_confirmation') {
      this.readOptions();
    }
  }

  private readOptions() {
    if (this.dashboardContext.getContextValue('requires_value_confirmation') != null) {
      this.requiresValueConfirmation = this.dashboardContext.getContextValue('requires_value_confirmation');
    } else {
      this.requiresValueConfirmation = false;
    }

    if (this.dashboardContext.getContextValue('showHints') != null) {
      this.showHints = this.dashboardContext.getContextValue('showHints');
    } else {
      this.showHints = false;
    }
  }

  onSetElementAndContext() {
    this.transportDetails = new Transport({
      masterdata: {
        carrier: this.dashboardContext.getContextValue(TerminalContextConstants.carrier),
        supplier: this.dashboardContext.getContextValue(TerminalContextConstants.supplier),
        driverName: this.dashboardContext.getContextValue(TerminalContextConstants.driver),
        coDriver: this.dashboardContext.getContextValue(TerminalContextConstants.coDriver),
        numberPlate: this.dashboardContext.getContextValue(TerminalContextConstants.numberPlate),
        phone: this.dashboardContext.getContextValue(TerminalContextConstants.phoneNumber),
        string1: this.dashboardContext.getContextValue('string1'),
        string2: this.dashboardContext.getContextValue('string2'),
        firstLoadCarrier: {
          trailerNumberPlate: this.dashboardContext.getContextValue(TerminalContextConstants.trailerNumberPlate),
          orderReference: this.dashboardContext.getContextValue(TerminalContextConstants.orderReference)
        }
      }
      });
  }

  public validStateChanged(valid: boolean) {
    if (this.dashboardContext) {
      this.dashboardContext.setContextValue(TerminalContextConstants.transportMasterdataValidityState, valid);
    }
  }

  public onTransportDetailsChanged() {
    this.dashboardContext.setContextValue(TerminalContextConstants.carrier, this.transportDetails.masterdata.carrier);
    this.dashboardContext.setContextValue(TerminalContextConstants.supplier, this.transportDetails.masterdata.supplier);
    this.dashboardContext.setContextValue(TerminalContextConstants.driver, this.transportDetails.masterdata.driverName);
    this.dashboardContext.setContextValue(TerminalContextConstants.coDriver, this.transportDetails.masterdata.coDriver);
    this.dashboardContext.setContextValue(TerminalContextConstants.numberPlate, this.transportDetails.masterdata.numberPlate);
    this.dashboardContext.setContextValue(TerminalContextConstants.trailerNumberPlate, this.transportDetails.masterdata.firstLoadCarrier.trailerNumberPlate);
    this.dashboardContext.setContextValue(TerminalContextConstants.orderReference, this.transportDetails.masterdata.firstLoadCarrier.orderReference);
    this.dashboardContext.setContextValue(TerminalContextConstants.phoneNumber, this.transportDetails.masterdata.phone);
    this.dashboardContext.setContextValue('string1', this.transportDetails.masterdata.string1);
    this.dashboardContext.setContextValue('string2', this.transportDetails.masterdata.string2);
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
